import { Injectable, inject } from '@angular/core';
import { InvestigationFormState } from '../../states/investigation-form.state';
import { GetInvestigationFormsStateResult } from './get-investigation-forms-state.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationFormsStateUseCase {
  private readonly _state = inject(InvestigationFormState);

  public execute(): GetInvestigationFormsStateResult {
    return {
      investigationForms: this._state.investigationForms,
      investigationFormSelectedToEdit: this._state.investigationFormSelectedToEdit,
      fieldTypes: this._state.fieldTypes,
      fieldConstraintTypes: this._state.fieldConstraintTypes,
      loadingInvestigationForms: this._state.loadingInvestigationForms,
      loadingInvestigationForm: this._state.loadingInvestigationForm,
      errorInvestigationForms: this._state.errorInvestigationForms,
      errorInvestigationForm: this._state.errorInvestigationForm,
      savingInvestigationForm: this._state.savingInvestigationForm,
      investigationFormsCount: this._state.investigationFormsCount,
      hasInvestigationForms: this._state.hasInvestigationForms,
    };
  }
}
